import { authenticatedPatch } from '../../../api/request';

export const updateDoctorPersonalInfo = (userId, data, onFail) => {
  return authenticatedPatch(`/doctor-data/update-doctor-user/${userId}`, onFail, data);
};
